module.exports = __webpack_public_path__ + "img/freelancer.88b779ff.jpg";